module.exports = __webpack_public_path__ + "img/logo_trans.71d50352.png";